<div class="mb-3 flex align-items-center gap-2">
  <button
    pButton
    type="button"
    (click)="navigateToRegister()"
    class="p-button-success"
    pTooltip="一括登録画面へ"
    tooltipPosition="bottom">
    <i
      class="pi pi-plus"
      aria-hidden="true"></i>
    新規登録
  </button>
  <button
    pButton
    type="button"
    (click)="deleteSelected()"
    class="p-button-danger"
    [disabled]="selectedTrackings.length === 0 || loading"
    pTooltip="選択した項目を一括削除"
    tooltipPosition="bottom">
    <i
      class="pi pi-trash"
      aria-hidden="true"></i>
    選択削除 ({{ selectedTrackings.length }}件)
  </button>
</div>

<div class="table-header-sticky-outer">
  全{{ trackings.length.toLocaleString() }}件
  <p-table
    #mainTable
    [value]="trackings"
    [(selection)]="selectedTrackings"
    [loading]="loading"
    columnResizeMode="expand"
    tableStyleClass="p-datatable-responsive"
    class="table-header-sticky p-datatable-responsive"
    [paginator]="true"
    [rows]="50"
    [rowsPerPageOptions]="[25, 50, 100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{totalRecords} 件中 {first} 〜 {last}"
    paginatorPosition="both"
    dataKey="id"
    [globalFilterFields]="['amazonProduct.asin', 'amazonProduct.name', 'user.name', 'memo']">
    <ng-template #caption>
      <div class="table-caption">
        <div class="grid">
          <div class="col-8"></div>
          <div class="col-3">
            <p-iconfield class="ml-auto input-full">
              <p-inputicon class="pi pi-search" />
              <input
                pInputText
                class="input-full"
                type="text"
                (input)="mainTable.filterGlobal($any($event.target).value, 'contains')"
                placeholder="検索キーワード" />
            </p-iconfield>
          </div>
          <div class="col-1">
            <button
              pButton
              class="p-button-outlined"
              (click)="mainTable.clear()">
              <i
                class="pi pi-filter-slash"
                aria-hidden="true"></i>
              Clear
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th style="width: 4%">
          <p-tableheadercheckbox></p-tableheadercheckbox>
        </th>
        <th style="width: 7%">画像</th>
        <th style="width: 10%">Keepaグラフ</th>
        <th
          style="width: 9%"
          pSortableColumn="amazonProduct.asin">
          ASIN
          <p-sorticon field="amazonProduct.asin"></p-sorticon>
        </th>
        <th style="width: 22%">商品名</th>
        <th
          style="width: 8%"
          pSortableColumn="user.name">
          登録者
          <p-sorticon field="user.name"></p-sorticon>
        </th>
        <th
          style="width: 10%"
          pSortableColumn="createdAt">
          登録日時
          <p-sorticon field="createdAt"></p-sorticon>
        </th>
        <th
          style="width: 6%"
          pSortableColumn="probability">
          確率
          <p-sorticon field="probability"></p-sorticon>
        </th>
        <th style="width: 18%">メモ</th>
        <th style="width: 6%">操作</th>
      </tr>
    </ng-template>

    <ng-template
      #body
      let-tracking>
      <tr>
        <td>
          <p-tablecheckbox [value]="tracking"></p-tablecheckbox>
        </td>
        <td>
          <a
            href="https://keepa.com/#!product/5-{{ tracking.amazonProduct.asin }}"
            target="_blank">
            @if (tracking.amazonProduct.imageUrl) {
              <img
                [src]="tracking.amazonProduct.imageUrl"
                style="width: 60px; height: auto"
                alt="商品画像" />
            }
          </a>
        </td>
        <td>
          <app-keepa-graph [asin]="tracking.amazonProduct.asin"></app-keepa-graph>
        </td>
        <td>
          <a
            href="https://www.amazon.co.jp/dp/{{ tracking.amazonProduct.asin }}"
            target="_blank">
            {{ tracking.amazonProduct.asin }}
          </a>
          @if (tracking.amazonProduct.keepaProduct?.boughtPastMonth != null) {
            <br />
            前月販売:
            {{
              tracking.amazonProduct.keepaProduct.boughtPastMonth < 10
                ? '9以下'
                : tracking.amazonProduct.keepaProduct.boughtPastMonth
            }}
          }
        </td>
        <td>
          <div
            class="text-overflow-ellipsis"
            [title]="tracking.amazonProduct.name">
            {{ tracking.amazonProduct.name }}
          </div>
        </td>
        <td>{{ tracking.user.name }}</td>
        <td>{{ formatDate(tracking.createdAt) }}</td>
        <td>
          @if (tracking.probability != null) {
            <span [ngClass]="probabilityColorClass(tracking.probability)">{{ tracking.probability }}%</span>
          } @else {
            -
          }
        </td>
        <td>
          <div class="flex align-items-center gap-2">
            <div
              class="text-overflow-ellipsis flex-1"
              [title]="tracking.memo">
              {{ tracking.memo || '-' }}
            </div>
            <i
              class="pi pi-user-edit clickable"
              style="font-size: 1rem; cursor: pointer; color: #007ad9"
              (click)="openEditDialog(tracking)"
              pTooltip="メモ・確率を編集"
              tooltipPosition="top"></i>
          </div>
        </td>
        <td>
          <i
            class="pi pi-trash clickable"
            style="font-size: 1rem; cursor: pointer; color: #dc3545"
            (click)="deleteTracking(tracking)"
            pTooltip="削除"
            tooltipPosition="top"></i>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td
          colspan="10"
          class="text-center">
          データがありません
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- メモ・確率編集モーダル (Unit 6) -->
<p-dialog
  header="メモ・確率を編集"
  [(visible)]="showEditDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  @if (currentTracking) {
    <div class="grid">
      <div class="col-12 mb-3">
        <div class="flex align-items-center gap-2">
          @if (currentTracking.amazonProduct.imageUrl) {
            <img
              [src]="currentTracking.amazonProduct.imageUrl"
              style="width: 40px; height: auto"
              alt="商品画像" />
          }
          <div>
            <div class="font-semibold">{{ currentTracking.amazonProduct.name }}</div>
            <div class="text-sm text-color-secondary">ASIN: {{ currentTracking.amazonProduct.asin }}</div>
          </div>
        </div>
      </div>
      <div class="col-12 mb-3">
        <label for="probabilityInput">仕入れ成功確率 (0-100、空欄で未設定)</label>
        <p-inputnumber
          id="probabilityInput"
          [(ngModel)]="probabilityInput"
          [min]="0"
          [max]="100"
          [showButtons]="true"
          placeholder="0-100"
          class="w-full"
          inputStyleClass="w-full"></p-inputnumber>
        <div class="mt-2">
          <button
            pButton
            type="button"
            class="p-button-text p-button-sm"
            (click)="probabilityInput = null">
            <i
              class="pi pi-times"
              aria-hidden="true"></i>
            確率をクリア
          </button>
        </div>
      </div>
      <div class="col-12">
        <label for="memoTextarea">メモ</label>
        <textarea
          id="memoTextarea"
          rows="4"
          class="p-inputtext w-full"
          pTextarea
          [(ngModel)]="memoText"
          placeholder="メモを入力してください"></textarea>
      </div>
      <div class="col-12 flex justify-content-end gap-2 mt-3">
        <button
          pButton
          type="button"
          class="p-button-outlined"
          [disabled]="saving"
          (click)="closeEditDialog()">
          キャンセル
        </button>
        <button
          pButton
          type="button"
          [loading]="saving"
          [disabled]="saving"
          (click)="saveEdit()">
          @if (saving) {
            <i
              class="pi pi-spin pi-spinner"
              aria-hidden="true"></i>
          }
          保存
        </button>
      </div>
    </div>
  }
</p-dialog>
